import clipTextBase from './base';
import createCanvas from './createCanvas';
import emojiList from '../emoji';

/**
 * 支持右下角按钮的多行文本省略
 * @param {Object} options - 配置参数
 * @param {string} options.content - 文本内容
 * @param {number} options.line - 文本行数
 * @param {string} options.ellipsis - 省略文本，默认为...
 * @param {string} options.addonDom - 右下角“更多”按钮的dom节点
 * @param {string} options.wrapDom - 整个文本区域的的dom节点
 * @param {Array} options.emoji - emoji列表
 * @param {number} options.emojiWidth - 单个emoji的真实宽度
 * @return {Object} 返回值对象，属性分别为 text 裁剪之后的文本  overflow 是否超出限定行数 line 限定行数
 */
const clipText = options => {
    const {
        content,
        line,
        ellipsis,
        addonDom,
        wrapDom,
        prefixDom,
        emoji = emojiList,
        emojiWidth: paramEmojiWidth,
    } = options;
    const wrapWidth = wrapDom.offsetWidth;
    const addonWidth = addonDom ? addonDom.offsetWidth : 0;
    const prefixWidth = prefixDom ? prefixDom.offsetWidth : 0;
    const fontStyle = window.getComputedStyle(wrapDom).fontStyle;
    const fontVariant = window.getComputedStyle(wrapDom).fontVariant;
    const fontWeight = window.getComputedStyle(wrapDom).fontWeight;
    const fontSize = window.getComputedStyle(wrapDom).fontSize;
    const lineHeight = window.getComputedStyle(wrapDom).lineHeight;
    const fontFamily = window.getComputedStyle(wrapDom).fontFamily;

    // 单例的canvas dom对象
    const cvs = createCanvas();
    // 获取canvas的上下文
    const ctx = cvs.getContext('2d');

    let emojiWidth = paramEmojiWidth;

    if (!emojiWidth) {
        const docWidth = Math.min(window?.__IFENG_ENV__?.maxDocWidth || 812, window.innerWidth);

        emojiWidth = (37.5 * docWidth) / 750;
    }

    return clipTextBase({
        ctx,
        content,
        line,
        ellipsis,
        addonWidth,
        prefixWidth,
        wrapWidth,
        fontStyle,
        fontVariant,
        fontWeight,
        fontSize,
        lineHeight,
        fontFamily,
        emoji,
        emojiWidth,
    });
};

export default clipText;
